import React from 'react';
import { connect } from 'react-redux';
import Pagination from '../pagination';

// For both /content and /people
import { filterUpdatePage } from '../../../actions/shared/index/filter';

const IndexPagination = ({ currentPage, totalPages, onPageSelect }) => {
  if (totalPages > 1)
    return (
      <Pagination
        pages={totalPages}
        selected={currentPage}
        pageSelectCallback={page => onPageSelect(page)}
      />
    );
  return false;
};

const mapStateToProps = ({ data, filter }) => ({
  currentPage: parseInt(filter.page, 10),
  totalPages: data.pageCount,
});

const mapDispatchToProps = dispatch => ({
  onPageSelect: page => dispatch(filterUpdatePage(page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IndexPagination);
